/* eslint-disable react/prop-types */
import Button from '@mui/material/Button';
import styles from './Buttons.module.css';
import { styled } from '@mui/material/styles';

const ColorButton = styled(Button)(({ theme }) => ({
    color: 'var(--intertek-blue-7)',
    border: '1px solid var(--intertek-blue-9)',
    backgroundColor: 'rgba(0,0,0,0)',
    '&:hover': {
        backgroundColor: 'rgba(0,0,0,0)',
        boxShadow:'none'
    },
    padding: '13px 25px',
    margin: '2px',
  
    fontSize: '18px',
    letterSpacing: '-0.03em',
    borderRadius: '100px',
    minHeight: '58px',
    fontFamily: 'Neo Sans',
    minWidth: '140px',
    textTransform: 'none',
    boxShadow:'none'
}));
export default function OutlineButton(props) {
    const { children, onClick, ...otherProps } = props;

    function handleClick(e) {
        if (onClick) {
            onClick(e);
        }
    }

    return (
        <ColorButton
            onClick={handleClick}
            className={`${styles.ButtonBase} ${styles.ButtonYellow}`}
            variant="contained"
            {...otherProps} // Pass down all other props to the Button component
        >
            {children}
        </ColorButton>
    );
}
